import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { GlobalService } from 'app/services/global.service';
import {
	InsightSugestion,
	InsightsClariService,
} from 'app/services/insights-clari.service';
import { UserService } from 'app/services/user.service';

@Component({
	selector: 'insights-clari-sugestions',
	templateUrl: './insights-clari-sugestions.component.html',
	styleUrls: ['./insights-clari-sugestions.component.scss'],
})
export class InsightsClariSugestionsComponent implements OnInit {
	public insightSugestions: InsightSugestion[] = [];
	public SCROLL_PIXEL_SIZE = 0;
	public isMobile: boolean;
	public activeTiers: string[] = [];
	public isLoadingTiers = true;
	public allTiers: string[] = [
		'plan_tier:diamond',
		'plan_tier:silver',
		'plan_tier:gold',
		'plan_tier:standard',
	];

	constructor(
		public atService: ActionTrackerService,
		public global: GlobalService,
		public cdr: ChangeDetectorRef,
		public insightsClariService: InsightsClariService,
		public userService: UserService
	) {}

	ngOnInit(): void {
		this.insightSugestions = this.insightsClariService.getSugestions();
		this.isMobile = this.global.isMobileDevice();
		this.SCROLL_PIXEL_SIZE = !this.isMobile ? 100 : 50;
		this.userService.getProfileData().then((response) => {
			this.activeTiers = response.canAcceptTags;
			this.isLoadingTiers = false;

			if (!this.hasAllTiers()) {
				this.atService.eventTracker(
					SCOPE_TYPE.Insights,
					SUBSCOPE_TYPE.Banner,
					ITEM_TYPE.TierSugestion,
					INTERACTION_TYPE.Seen
				);
			}
		});
		this.cdr.detectChanges();
	}

	changePage(direction: ScrollDirection): void {
		if (this.isScrollDisabled(direction)) {
			return;
		}

		const firstQuestion = document.querySelector<HTMLElement>(
			'.insights-questions:first-child'
		);

		firstQuestion.scrollTo({
			left: this.resolveScrollAmount(firstQuestion, direction),
			behavior: 'auto',
		});
	}

	resolveScrollAmount(
		element: HTMLElement,
		direction: ScrollDirection
	): number {
		if (direction === 'right') {
			return element.scrollLeft + element.clientWidth + this.SCROLL_PIXEL_SIZE;
		}

		return element.scrollLeft - element.clientWidth - this.SCROLL_PIXEL_SIZE;
	}

	isScrollDisabled(direction: ScrollDirection): boolean {
		const firstQuestion = document.querySelector<HTMLElement>(
			'.insights-questions:first-child'
		);

		const scrollPosition = firstQuestion.scrollLeft;

		if (direction === 'right') {
			const totalScrollWidth =
				firstQuestion.scrollWidth - firstQuestion.clientWidth;
			return totalScrollWidth - scrollPosition < this.SCROLL_PIXEL_SIZE;
		}

		return scrollPosition < this.SCROLL_PIXEL_SIZE;
	}

	trackClariSuggestionOpen(sugestion: string): void {
		this.atService.eventTracker(
			SCOPE_TYPE.Insights,
			SUBSCOPE_TYPE.Banner,
			ITEM_TYPE.Redirect,
			INTERACTION_TYPE.Click,
			{
				selected: sugestion,
			}
		);
	}

	hasAllTiers(): boolean {
		return this.allTiers.every((tier) => this.activeTiers.includes(tier));
	}
}

type ScrollDirection = 'left' | 'right';
